import { render, staticRenderFns } from "./CardTasks.vue?vue&type=template&id=dd8431f8&scoped=true"
import script from "./CardTasks.vue?vue&type=script&lang=js"
export * from "./CardTasks.vue?vue&type=script&lang=js"
import style0 from "./CardTasks.vue?vue&type=style&index=0&id=dd8431f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8431f8",
  null
  
)

export default component.exports